module.exports = __webpack_public_path__ + "static/img/btn-start.23c662d8.png";